import React from 'react';
import { breadcrumbsPropTypes } from './BreadcrumbsPropTypes';
import * as styles from './Breadcrumbs.module.scss';
const Breadcrumbs = _ref => {
  let {
    items,
    classname
  } = _ref;
  if (!items) {
    return null;
  }
  return /*#__PURE__*/React.createElement("ul", {
    className: `${styles.root} ${classname || ''}`
  }, items.map((_ref2, index) => {
    let {
      label,
      title,
      href
    } = _ref2;
    const Component = href ? 'a' : 'span';
    return /*#__PURE__*/React.createElement("li", {
      className: styles.rootItem,
      key: index
    }, /*#__PURE__*/React.createElement(Component, {
      href: href,
      title: title,
      className: styles.rootItemElement
    }, label));
  }));
};
export default Breadcrumbs;